<template>
  <b-card>
    <div class="d-flex justify-content-between">
      <div class="flex-grow-1">
        <b-form-group>
          <label>
            <b> {{ $t('expression') + ' :' }} </b>
          </label>

          <!--           <b-input-group class="flex-w-stretch">
            <b-input-group-prepend>
              <b-btn
                :variant="associated_expression_metavariables_button_variant"
                :disabled="!in_edition"
                @click="
                  local_value.associated_expression_contains_metavariables = !local_value.associated_expression_contains_metavariables
                "
              >
                <span class="fas fa-code" />
              </b-btn>
            </b-input-group-prepend>
            <b-form-input
              v-model="local_value.associated_expression"
              :disabled="!in_edition"
            />
          </b-input-group> -->

          <b-form-input
            class="flex-w-stretch"
            v-model="local_value.associated_expression"
            :disabled="!in_edition"
          />
          <!--              <b-input-group v-if="in_edition" class="flex-w-stretch" :disabled="!in_edition">
                <b-input-group-prepend>
                  <b-btn
                    :variant="metavariables_button_variant"
                    @click="contains_metavariables = !contains_metavariables"
                  >
                    <span class="fas fa-code" />
                  </b-btn>
                </b-input-group-prepend>
                <b-form-input
                  v-model="local_value.associated_expression"
                  :placeholder="$t('enter_column_name')"
                />
              </b-input-group> -->
        </b-form-group>

        <b-form-radio-group
          v-model="local_value.upload_category"
          stacked
          :disabled="!in_edition"
        >
          <b-form-radio value="new">
            <b> {{ $t('file_upload') }} </b>
          </b-form-radio>
          <b-collapse
            :id="nuid"
            :visible="local_value.upload_category === 'new'"
          >
            <!--             <b-card align="center" :header="$t('file_upload')">
              <file-uploader
                :project_id="project_id"
                @success="validate_file($event)"
              />
              <b-button
                variant="outline-secondary"
                class="btn mt-3"
                @click="reset_file"
              >
                {{ $t('change_file') }}
              </b-button>
            </b-card> -->
            <b-card
              align="center"
              :header="$t('file_upload')"
              v-if="in_edition"
            >
              <!--               <file-uploader
                :project_id="project_id"
                @success="validate_file($event)"
              /> -->
              <file-uploader
                :key="file_uploader_id"
                :project_id="project_id"
                @success="validate_file($event)"
              />
              <!--               <b-button
                variant="outline-secondary"
                class="btn mt-3"
                @click="reset_file"
              >
                {{ $t('change_file') }}
              </b-button> -->
            </b-card>
            <div v-else class="h4 ml-5">
              {{ local_value.name }}
            </div>
          </b-collapse>

          <b-form-radio value="existing">
            <b> {{ $t('already_uploaded_file') }} </b>
          </b-form-radio>
          <b-collapse
            :id="euid"
            :visible="local_value.upload_category === 'existing'"
          >
            <b-card
              v-if="rawfiles_existing && in_edition"
              align="center"
              :header="$t('already_uploaded_file')"
            >
              <!--               <b-form-select
                v-model="rawfile_selected"
                :options="rawfile_selection_options"
                class="mb-3"
              /> -->
              <!--               <b-form-select
                v-if="in_edition"
                v-model="rawfile_selected"
                :options="rawfile_selection_options"
                class="mb-3"
              /> -->
              <b-form-select
                v-model="local_value.uploaded_rawfile_uid"
                :options="rawfile_selection_options"
                @change="validate_edition()"
                class="mb-3"
              />
              <!--               <b-button
                class="btn mt-3"
                variant="outline-secondary"
                @click="select_already_uploaded_file"
              >
                {{ $t('select_this_file') }}
              </b-button> -->
            </b-card>
            <div v-else class="h4 ml-5">
              {{ local_value.name }}
            </div>
          </b-collapse>

          <b-form-radio value="server">
            <b> {{ $t('fetch_from_server_filesystem') }} </b>
          </b-form-radio>

          <b-collapse
            :id="suid"
            :visible="local_value.upload_category === 'server'"
          >
            <!--             <b-card align="center" :header="$t('fetch_from_server_filesystem')"> -->
            <b-card
              v-if="in_edition"
              align="center"
              :header="$t('fetch_from_server_filesystem')"
            >
              <!--               <filepath-selector
                v-model="generic_path"
                :is_open="true"
              ></filepath-selector> -->
              <filepath-selector
                v-model="local_value.generic_sourcefilepath"
                :is_open="true"
              ></filepath-selector>
              <!--               <b-button
                class="btn mt-3"
                variant="outline-secondary"
                @click="select_path"
              >
                {{ $t('select_path') }}
              </b-button> -->

              <b-form-checkbox
                v-model="local_value.active_folder_scanning_activated"
                name="active_folder_scanning_activated"
                :value="true"
                :unchecked-value="false"
              >
                {{ $t('active_folder_scanning_activated') }}
              </b-form-checkbox>
            </b-card>

            <div v-else class="h4 ml-5">
              <div>
                {{
                  $t('path') + ' : ' + local_value.generic_sourcefilepath.path
                }}
              </div>
              <div>
                {{
                  $t('active_folder_scanning_activated') +
                    ' : ' +
                    local_value.active_folder_scanning_activated
                }}
              </div>
            </div>
          </b-collapse>
        </b-form-radio-group>

        <!--    <b-container>
        <b-form-checkbox
          v-model="local_value.active_folder_scanning_activated"
          name="active_folder_scanning_activated"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t('active_folder_scanning_activated') }}
        </b-form-checkbox>
        <b-button
          variant="outline-secondary"
          class="btn mt-3"
          @click="reset_file"
        >
          {{ $t('change_file') }}
        </b-button>
      </b-container> -->
      </div>

      <div class="ml-4">
        <b-btn
          v-if="is_new_file_element"
          @click="validate_edition"
          variant="outline-secondary"
        >
          <span class="fas fa-fw fa-plus" />
        </b-btn>
        <b-btn-group v-else>
          <b-btn @click="toggle_edition" variant="outline-secondary">
            <span
              class="fas fa-fw"
              :class="in_edition ? 'fa-check' : 'fa-pen'"
            />
          </b-btn>
          <b-btn @click="delete_button_on" variant="outline-secondary">
            <span class="fas fa-fw fa-trash" />
          </b-btn>
        </b-btn-group>
      </div>
    </div>
  </b-card>
</template>

<i18n>
{
  "en": {
    "expression": "Expression",
    "already_uploaded_file": "Use an already uploaded file",
    "select_this_file": "Select this file",
    "choose_already_uploaded_file": "Choose an already uploaded file",
    "file_upload": "File upload",
    "change_file": "Change file",
    "text_upload_in_progress": "Are you sure you want to leave the page and lose the file(s) being uploaded ?",
    "bytes_uploaded_on": "bytes uploaded",
    "fetch_from_server_filesystem": "Fetch from server filesystem",
    "path": "Path",
    "select_path": "Select this path",
    "active_folder_scanning_activated": "Active folder scanning activated (deleted file is not remembered in workflow)"

  },
  "fr": {
    "expression": "Expression",
    "already_uploaded_file": "Utiliser un fichier déjà uploadé",
    "select_this_file": "Sélectionner ce fichier",
    "choose_already_uploaded_file": "Choississez un fichier déja uploadé",
    "file_upload": "Upload d'un fichier",
    "change_file": "Changement de fichier",
    "text_upload_in_progress": "Voulez-vous quitter la page malgré les fichiers en cours d'upload qui seront perdus ?",
    "bytes_uploaded_on": "octets uploadé",
    "fetch_from_server_filesystem": "Récupérer depuis le système de fichiers du serveur",
    "path": "Chemin",
    "select_path": "Sélectionner ce chemin",
    "active_folder_scanning_activated": "Scan de répertoire permanent activé (un fichier supprimé est supprimé dans le workflow)"
  }
}
</i18n>

<style scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
/* Hide the delete button initially */
.dz-preview >>> .delete {
  display: none;
}

/* Hide the start and cancel buttons and show the delete button */
.dz-preview >>> .dz-complete .start,
.dz-preview >>> .dz-complete .cancel {
  display: none;
}
.dz-preview >>> .dz-complete .delete {
  display: block;
}
</style>

<script>
import _ from 'lodash'
import Vue from 'vue'
import draggable from 'vuedraggable'

import { mapGetters } from 'vuex'

import {
  formatted_integer_with_thousand_spaces,
  formatted_moment_localized,
} from '@/utils.js'

import { file_brick_upload_completed } from '@/api/subscriptions.js'

import { GenericPath, FileInfosEntity } from '@/components/object_model.js'

import FilepathSelector from '@/components/filepath_selector.vue'
import FileUploader from '@/components/file_uploader.vue'

// *****************************************************************************

export default {
  name: 'FileSelectionElement',
  components: {
    draggable,
    FilepathSelector,
    FileUploader,
  },
  props: [
    'value',
    'in_edition',
    'is_new_file_element',
    'project_id',
    'brick_id',
  ],

  data() {
    // const did = 'dropzone' + _.uniqueId()
    // const idref = '#' + did
    return {
      file_uploader_id: _.uniqueId('file_uploader'),
      nuid: _.uniqueId('new-'),
      euid: _.uniqueId('existing-'),
      suid: _.uniqueId('server-'),
      // local_value: new FileInfosEntity(),
      local_value: undefined,

      // rawfile_selected: null,
      // upload_category: 'new',
      // generic_path: new GenericPath(),
    }
  },

  computed: {
    // _() {
    //   return _
    // },
    rawfiles_undeleted() {
      return this.automl_rawfiles_undeleted_object_per_project(this.project_id)
    },

    rawfiles_existing() {
      let res = this.rawfiles_undeleted.lists !== []
      if (this.rawfiles_undeleted.lists !== []) {
        res = true
      }
      return res
    },

    rawfile_selection_options() {
      let self = this
      let res = _.map(this.rawfiles_undeleted.lists, function(rawfile_uid) {
        let elt = self.rawfiles_undeleted.rawfiles[rawfile_uid]
        return {
          value: elt.uid,
          text: `${elt.name} (${formatted_integer_with_thousand_spaces(
            elt.size
          )} ${self.$t('bytes_uploaded_on')} ${formatted_moment_localized(
            elt.creation_dt,
            self.i18n_locale
          )})`,
        }
      })

      res.push({ value: -1, text: this.$t('choose_already_uploaded_file') })

      return res
    },

    // associated_expression_metavariables_button_variant() {
    //   let res
    //   if (this.local_value.associated_expression_contains_metavariables) {
    //     res = 'secondary'
    //   } else {
    //     res = 'outline-secondary'
    //   }
    //   return res
    // },

    ...mapGetters(['automl_rawfiles_undeleted_object_per_project']),
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          this.local_value = _.cloneDeep(nv)
          this.file_uploader_id = _.uniqueId('file_uploader')
          this.upload_category = 'new'

          // this.generic_path = _.cloneDeep(nv.local_value)
        }
      },
    },

    // local_value: {
    //   immediate: true,
    //   deep: true,
    //   handler(nv, ov) {
    //     let rawfile_uid = nv.uploaded_rawfile_uid
    //     if (
    //       rawfile_uid === -1 ||
    //       _.isUndefined(rawfile_uid) ||
    //       _.isNull(rawfile_uid)
    //     ) {
    //       this.local_value.name = ''
    //     } else {
    //       let rawfiles = this.rawfiles_undeleted.rawfiles
    //       this.local_value.name = ((rawfiles || {})[rawfile_uid] || {}).name
    //     }
    //   },
    // },

    local_value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (nv.upload_category === 'existing') {
          let rawfile_uid = nv.uploaded_rawfile_uid
          if (rawfile_uid === -1 || _.isNil(rawfile_uid)) {
            this.local_value.name = ''
          } else {
            let rawfiles = this.rawfiles_undeleted.rawfiles
            this.local_value.name = ((rawfiles || {})[rawfile_uid] || {}).name
          }
        }
      },
    },
  },
  methods: {
    // async select_already_uploaded_file() {
    //   // TODO : Need to get the name of the file associated with the rawfile
    //   if (this.rawfile_selected != null) {
    //     let rawfiles = this.rawfiles_undeleted.rawfiles
    //     let name = rawfiles[this.rawfile_selected].name
    //     await generic_update(this.project_id, {
    //       uid: this.brick_id,
    //       uploaded_rawfile_uid: this.rawfile_selected,
    //       generic_sourcefilepath: null,
    //       name: name,
    //     })
    //   }
    // },

    // validate_edition() {
    //   const valid_entry =
    //     ((this.local_value.upload_category == 'new' ||
    //       this.local_value.upload_category == 'existing') &&
    //       this.local_value.uploaded_rawfile_uid !== -1) ||
    //     (this.local_value.upload_category == 'server' &&
    //       this.generic_path.path !== '')
    //   console.log(
    //     'In validate edition',
    //     JSON.stringify(this.local_value),
    //     valid_entry
    //   )

    //   if (valid_entry) {
    //     let res = _.cloneDeep(this.local_value)
    //     res.selected_path = this.generic_path
    //     this.$emit('input', res)
    //     this.generic_path = new GenericPath()
    //     this.upoad_category = 'new'
    //   }
    // },
    validate_edition() {
      let valid_entry =
        ((this.local_value.upload_category === 'new' ||
          this.local_value.upload_category === 'existing') &&
          this.local_value.uploaded_rawfile_uid !== -1) ||
        (this.local_value.upload_category === 'server' &&
          this.local_value.generic_sourcefilepath.path !== '')

      valid_entry = valid_entry && this.local_value.associated_expression !== ''

      if (valid_entry) {
        let res = _.cloneDeep(this.local_value)
        this.$emit('input', res)
      }
    },
    delete_element(index) {
      this.local_value.splice(index, 1)
    },

    toggle_edition() {
      if (this.in_edition) {
        this.validate_edition()
      } else {
        this.$emit('start_editing')
      }
    },

    delete_button_on() {
      this.$emit('delete')
    },

    // async select_path() {
    //   await generic_update(this.project_id, {
    //     uid: this.brick_id,
    //     uploaded_rawfile_uid: -1,
    //     generic_sourcefilepath: this.generic_path,
    //   })
    // },

    // async select_path() {
    //   this.local_value.selected_path = this.generic_path
    //   this.uploaded_rawfile_uid = -1
    // },

    // async reset_file() {
    //   let default_name = _.join(
    //     [this.cur_brick.default_name, this.brick_id],
    //     '_'
    //   )
    //   await generic_update(this.project_id, {
    //     uid: this.brick_id,
    //     name: default_name,
    //     uploaded_rawfile_uid: -1,
    //     generic_sourcefilepath: null,
    //     metavariables_dict_to_rawfile_uid: {},
    //     metavariables_dict_to_last_file_check: {},
    //   })
    // },
    async validate_file(token) {
      let rawfile = await file_brick_upload_completed(
        this.project_id,
        this.brick_id,
        token
      )
      this.local_value.name = rawfile.name
      this.local_value.uploaded_rawfile_uid = rawfile.uploaded_rawfile_uid
      // this.$emit('selected_file')
      this.validate_edition()
    },
  },
}
</script>
